<template>
  <div style="padding: 0 15px;">
    <el-form ref="channelPostForm" :model="postForm" label-position="left" label-width="70px">
      <el-form-item label="设备号">
        <el-input v-model="postForm.value" placeholder="请输入内容" />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="postForm.remark" placeholder="请输入内容" />
      </el-form-item>
      <el-button type="primary" @click="createData"> 保存 </el-button>
    </el-form>
  </div>
</template>

<script>

export default {
  name: 'FaceDeviceUpdate',
  components: {

  },
  props: {
    item: {
      type: [Object],
      required: false,
      default() {
        return {}
      }
    }

  },
  data() {
    return {
      postForm: {}
    }
  },
  watch: {

  },
  created() {
    // this.postForm.shop_id = this.shopId
    this.postForm = Object.assign({}, this.item)
  },
  methods: {
    createData() {
      if (!this.postForm.value) {
        this.$message({
          type: 'error',
          message: '请输入设备号'
        })
        return
      }
      this.$http.setShopValue(this.postForm).then(res => {
        this.$message({
          type: 'success',
          message: '添加成功'
        })
        this.$emit('successCBK')
      })
    }

  }
}
</script>

<style scoped>
  .dialog-footer{
    text-align: right;
  }
</style>
